import { CommonModule } from '@angular/common';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { clearLocalStorageExceptLastLoginService } from '@core/services/clearLocalStorageExceptLastLogin.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthService } from 'authen-service-library';
import { NzIconModule, NzIconService } from 'ng-zorro-antd/icon';
import { NzMessageService } from 'ng-zorro-antd/message';
import { filter } from 'rxjs';
import { authNoOIDC } from 'src/environments/auth/auth-config.prod';
import { environment } from '../environments/environment';
import {
  CheckIcon,
  CheckSquare,
  CirclePlusIcon,
  DeleteIcon,
  LocationIcon,
  PencilIcon,
  PortIcon,
  SearchIcon,
  StoreIcon,
  TrashBinIcon,
  additionalFeeIcon,
  arrowLeftIcon,
  arrowRightIcon,
  billInforIcon,
  closeEyeIcon,
  containerIcon,
  copyIcon,
  customerIcon,
  dashboardIcon,
  driverIcon,
  emailIcon,
  invoiceIcon,
  keyIcon,
  locationIcon,
  mapAndLocation,
  openEyeIcon,
  orderICon,
  phoneIcon,
  portIcon,
  queVoIcon,
  shippingLinesIcon,
  sortIcon,
  tractorIcon,
} from './share/iconAntd';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NzIconModule, CommonModule, TranslateModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'Base';
  isLoginWithAuth2: boolean = false;
  endpoint = environment.API_URL_NO_AUTH2;
  private blurListener!: () => void;

  constructor(
    private oauthService: OAuthService,
    private translate: TranslateService,
    private authService: AuthService,
    private iconService: NzIconService,
    private mess: NzMessageService,
    private router: Router,
    private clearLocalStorageExceptLastLoginService: clearLocalStorageExceptLastLoginService,
    private renderer: Renderer2
  ) {
    this.iconService.addIconLiteral('mapAndLocation:antd', mapAndLocation);
    this.iconService.addIconLiteral('order:antd', orderICon);
    this.iconService.addIconLiteral('port:antd', portIcon);
    this.iconService.addIconLiteral('container:antd', containerIcon);
    this.iconService.addIconLiteral('tractor:antd', tractorIcon);
    this.iconService.addIconLiteral('customer:antd', customerIcon);
    this.iconService.addIconLiteral('location:antd', locationIcon);
    this.iconService.addIconLiteral('shippingLines:antd', shippingLinesIcon);
    this.iconService.addIconLiteral('driver:antd', driverIcon);
    this.iconService.addIconLiteral('invoice:antd', invoiceIcon);
    this.iconService.addIconLiteral('additionalFee:antd', additionalFeeIcon);
    this.iconService.addIconLiteral('pencil:antd', PencilIcon);
    this.iconService.addIconLiteral('trashbin:antd', TrashBinIcon);
    this.iconService.addIconLiteral('search:antd', SearchIcon);
    this.iconService.addIconLiteral('check:antd', CheckIcon);
    this.iconService.addIconLiteral('delete:antd', DeleteIcon);
    this.iconService.addIconLiteral('circlePlus:antd', CirclePlusIcon);
    this.iconService.addIconLiteral('checkSquare:antd', CheckSquare);
    this.iconService.addIconLiteral('port:antd', PortIcon);
    this.iconService.addIconLiteral('store:antd', StoreIcon);
    this.iconService.addIconLiteral('location:antd', LocationIcon);
    this.iconService.addIconLiteral('arrowLeftIcon:antd', arrowLeftIcon);
    this.iconService.addIconLiteral('arrowRightIcon:antd', arrowRightIcon);
    this.iconService.addIconLiteral('emailIcon:antd', emailIcon);
    this.iconService.addIconLiteral('phoneIcon:antd', phoneIcon);
    this.iconService.addIconLiteral('keyIcon:antd', keyIcon);
    this.iconService.addIconLiteral('openEyeIcon:antd', openEyeIcon);
    this.iconService.addIconLiteral('closeEyeIcon:antd', closeEyeIcon);
    this.iconService.addIconLiteral('billInforIcon:antd', billInforIcon);
    this.iconService.addIconLiteral('dashboardIcon:antd', dashboardIcon);
    this.iconService.addIconLiteral('sortIcon:antd', sortIcon);
    this.iconService.addIconLiteral('copyIcon:antd', copyIcon);
    this.iconService.addIconLiteral('queVoIcon:antd', queVoIcon);

    this.authService.config = {
      loginURl: this.endpoint + `/users/login`,
      refreshTokenURL: this.endpoint + `/users/refresh-token`,
      timeToRefreshToken: 60000,
      logoutURL: this.endpoint + `/users/logout`,
    };
    this.translate.setDefaultLang('en');
    if (this.isLoginWithAuth2) {
      this.oauthService.loadDiscoveryDocumentAndTryLogin();
    } else {
      if (localStorage.getItem('access_token')) {
        this.authService.silentRefreshToken();
      }
    }
    // this.oauthService.silentRefreshRedirectUri = 'http://localhost:4200';
    // this.oauthService.setupAutomaticSilentRefresh();
  }

  ngOnInit(): void {
    this.authService.config = authNoOIDC;
    this.authService.config.refreshFunctionOfInterceptor = (): Promise<any> => {
      return this.authService.refreshTokenNoAuth2();
    };

    let expires_at: any = null;
    if (localStorage.getItem('expires_at')) {
      expires_at = new Date(Number(localStorage.getItem('expires_at') || ''));
    }
    const now: any = new Date();

    if (expires_at && expires_at < now) {
      this.mess.warning('Hết phiên đăng nhập.Vui lòng đăng nhập lại');
      this.clearLocalStorageExceptLastLoginService.clearLocalStorageExceptLastLogin();

      this.router.navigate(['/login']);
    }

    this.blurListener = this.renderer.listen(document, 'focusout', (event) => {
      const target = event.target as HTMLInputElement;
      if (
        target.tagName === 'INPUT' &&
        target.type === 'text' &&
        target.id !== 'password'
      ) {
        let value = target.value.trim().toUpperCase(); // Xóa khoảng trắng đầu & cuối
        if (value !== target.value) {
          target.value = value;
          target.dispatchEvent(new Event('input')); // Kích hoạt Angular update value
        }
      }
    });
  }
  ngOnDestroy() {
    if (this.blurListener) this.blurListener();
  }

  Login() {
    this.oauthService
      .fetchTokenUsingPasswordFlowAndLoadUserProfile(
        'administrator',
        'Administrator1'
      )
      .then((res) => {
        this.oauthService.events
          .pipe(filter((e: any) => e.type == 'token_expires'))
          .subscribe((e: any) => {
            this.oauthService.refreshToken();
          });
      })
      .catch((err) => {
        console.log('lỗi');
      });
  }

  refreshToken() {
    this.oauthService.refreshToken();
  }

  LoginNoAuth2() {
    this.isLoginWithAuth2 = false;
    this.authService.loginNoAuth2('dongnguyen', 'Dong2003@').then((res) => {
      console.log(res);

      this.authService.silentRefreshToken();
    });
  }
  refreshTokenNoAuth2() {
    this.authService.refreshTokenNoAuth2();
  }
  logout() {
    this.authService.logOutNoAuth2();
  }
}
